module.exports = __webpack_public_path__ + "static/img/sign.e267372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/top_message/sign.png
// module id = oD7v
// module chunks = 0